import React from 'react';

import type { CasinoRace } from '@swf/core/types/CasinoRaces';

import Completed from '../Completed/Completed';

import styles from './RaceBlock.scss';

export interface Props {
  path: string;
  races: CasinoRace[];
  showLeaderboard(racePath: string): () => void | Promise<void>;
}

const RaceBlock: React.FC<Props> = ({ path, races, showLeaderboard }) => (
  <>
    {races.map((race, index) => (
      <div key={race.id} className={styles.race}>
        <Completed onStanding={showLeaderboard(`${path}[${index}]`)} {...race} />
      </div>
    ))}
  </>
);

export default RaceBlock;
